module.exports = __webpack_public_path__ + "static/media/refresh-status-disabled.8958ccd4.svg";